import axios from 'axios';
import { useState } from 'react';
import { saveAs } from 'file-saver';
import swal from 'sweetalert';
//const API_URL = "https://groupnpay.com/icpanel/";
// const API_URL = "http://10.144.238.187:8081/icpanel/";
  // const API_URL = "http://192.168.3.133:8080/icpanel/";
    const API_URL = process.env.REACT_APP_ICPANEL_URL;
   // const API_URL = "https://testgruop.infocareerindia.com/icpanel/";
//const API_URL = 'https://groupnpay.com/icpanelt1/';

const Login = (email: any, password: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/login?employeeName=" + email + "&password=" + password)
        .then((response) => {
            console.log("response")
            return response;
        })
        .catch((error) => {
            console.log(error)
            return error;
        });
};

const HRDashBoardGetAllEmploye = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/employee")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const HRDashBoardGetAllClient = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/client")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const HRDashBoardGetAllProject = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/project")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const HRDashBoardGetTodayLeave = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/leave")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const HRViewEmployee = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/getAllEmployDetailsList")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const HRUpdateEmployee = (status: any, id: any) => {
    console.log("updated data", status, id)
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("employeeDetails/saveED?statusFlag=" + status + "&id=" + id,
        {
            id: id,
            statusFlag: status
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const ViewLeaveCount = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/myleaves?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const ViewLeaveCountInPopup = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/getBalance?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const GetLeaveDetails = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/myleaves?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};

const ApplyLeave = (fromDate: any, toDate: any, leaveType: any, reason: any, nodFloat: any, empCode: any, leaveId: any, status: any, reportingPerson: any, remarks: any, lopFlag: any, statusFlag: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    if (leaveId === "") {
        return api.post("leaveDetails/saveUpdateLeave",
            {
                fromDate: fromDate,
                toDate: toDate,
                leaveType: leaveType,
                reason: reason,
                noOfDays: nodFloat,
                empCode: empCode,
                leaveStatus: status
            }
        )
            .then((response) => {
                console.log(response)
                return response;
            })
            .catch((error) => {
                console.log(error);
                return error;
            });
    }
    else {
        return api.post("leaveDetails/saveUpdateLeave",
            {
                id: leaveId,
                fromDate: fromDate,
                toDate: toDate,
                leaveType: leaveType,
                reason: reason,
                noOfDays: nodFloat,
                empCode: empCode,
                leaveStatus: status,
                reportingPerson: [reportingPerson],
                remarks: remarks,
                status: statusFlag,
                lopFlag: lopFlag,
            }
        )
            .then((response) => {
                console.log(response)
                return response;
            })
            .catch((error) => {
                console.log(error);
                return error;
            });
    }

};

const CancelLeave = (fromDate: any, toDate: any, leaveType: any, reason: any, nodFloat: any, empCode: any, leaveId: any, sts: any, reportingPerson: any, remarks: any, lopFlag: any, statusFlag: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("leaveDetails/saveUpdateLeave",
        {
            id: leaveId,
            noOfDays: nodFloat,
            fromDate: fromDate,
            toDate: toDate,
            leaveType: leaveType,
            reason: reason,
            leaveStatus: sts,
            empCode: empCode,
            status: statusFlag,
            reportingPerson: [reportingPerson],
            remarks: remarks,

            lopFlag: lopFlag,
        }
    )
        .then((response) => {
            console.log(response)
            return response;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
}


const GetLeaveType = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/leavetypeOrder")
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};

const HRGetAllApproval = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/hrlist?id=" + id)
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};

const getEmployementTypeList = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("EmploymentTypes/getAllEmploymentTypesList")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const GetEmployeTypeViewId = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("EmploymentTypes/employmentTypesById?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const UpdateEmployeeType = (ETypeName: any, ETypeDescription: any, crtby: any, updtby: any, Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("EmploymentTypes/saveUpdateEmploymentType",
        {
            id: Id,
            employmentTypesName: ETypeName,
            employmentTypesDescription: ETypeDescription,
            createdBy: crtby,
            updatedBy: updtby,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};


const CreateEmployeeType = (eTName: any, eTDescription: any, crtby: any, updtby: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("EmploymentTypes/saveUpdateEmploymentType",
        {
            employmentTypesName: eTName,
            employmentTypesDescription: eTDescription,
            createdBy: crtby,
            updatedBy: updtby
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ViewEmpolyeeById = (id: any) => {
    console.log(id, "lj")
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/byid?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const GetAllGenderDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/allgender")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const AllBloodGroupsDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/bloodgroup")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetAllMaritalStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/allMartialStatus")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetEmployeeCategoryDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("EmploymentTypes/getAllEmploymentTypesList")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const GetAllEMployeeStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/allEmployeeStatus")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetAllDesignationDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("Designations/getAllDesignationsList")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const GetAllReportingManagerDropDown = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/allReportingPerson?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetAllBusinessUnitDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("businessUnit/getAllBusinessUnits")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetAllDepartmentUnitDropDown = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("masterDepartment/deptByBU?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const ViewAllProficiencyDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/proficiency")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const ViewAllBoardDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/board")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const EmployeePersonalSaveOrUpdate = (name: any, fathername: any, martialStatus: any, DOB: any, category: any, employeeStatus: any, gender: any, bloodGroup: any, mobile: any, contact: any, ERelationship: any, Location: any, Peraddressline1: any, Peraddressline2: any, Peraddressline3: any, Peraddressline4: any, addressline1: any, addressline2: any, addressline3: any, addressline4: any, empCode: any, doj: any, idb: any, phone: any, role: any, email: any, designation: any, lastname: any, personalemail: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    if (idb !== "") {
        return api
            .post("employeeDetails/saveED",
                {
                    id: idb,
                    name: name,
                    lastName: lastname,
                    personalEmailId: personalemail,
                    fathername: fathername,
                    employeeCode: empCode,
                    martialStatus: martialStatus,
                    dateOfBirth: DOB,
                    gender: gender,
                    bloodGroup: bloodGroup,
                    phone: phone,
                    mobile: mobile,
                    emergencyContactNumber: contact,
                    emergencyContactRelation: ERelationship,
                    employeeLocation: Location,
                    presentAddressLine1: addressline1,
                    presentAddressLine2: addressline2,
                    presentAddressCity: addressline3,
                    presentAddressPinCode: addressline4,
                    permanentAddressLine1: Peraddressline1,
                    permanentAddressLine2: Peraddressline2,
                    permanentAddressCity: Peraddressline3,
                    permanentAddressPinCode: Peraddressline4,
                    employeeStatus: employeeStatus,
                    dateOfJoining: doj,
                    employeeCategory: category,
                    emailId: email,
                    employmentDesignation: designation,
                    roleId: role,
                    statusFlag: status
                })
            .then((response) => {
                console.log("res---------->up", response);
                return response;
            })
            .catch((error) => {
                console.log("err---------->up", error);
                return error;
            });
    }
    else {
        return api
            .post("employeeDetails/saveED",
                {
                    name: name,
                    lastName: lastname,
                    personalEmailId: personalemail,
                    fathername: fathername,
                    employeeCode: empCode,
                    martialStatus: martialStatus,
                    dateOfBirth: DOB,
                    gender: gender,
                    bloodGroup: bloodGroup,
                    phone: phone,
                    mobile: mobile,
                    emergencyContactNumber: contact,
                    emergencyContactRelation: ERelationship,
                    employeeLocation: Location,
                    presentAddressLine1: addressline1,
                    presentAddressLine2: addressline2,
                    presentAddressCity: addressline3,
                    presentAddressPinCode: addressline4,
                    permanentAddressLine1: Peraddressline1,
                    permanentAddressLine2: Peraddressline2,
                    permanentAddressCity: Peraddressline3,
                    permanentAddressPinCode: Peraddressline4,
                    employeeStatus: employeeStatus,
                    dateOfJoining: doj,
                    employeeCategory: category,
                    emailId: email,
                    employmentDesignation: designation,
                    roleId: role,
                    statusFlag: status
                })
            .then((response) => {
                console.log("res---------->new", response);
                return response;
            })
            .catch((error) => {
                console.log("err---------->new", error);
                return error;
            });
    }
}

const EmployeeEducationalSaveOrUpdate = (xthinstitute: any, xthpassyear: any, xthboard: any, xthpercentage: any, xiithinstitute: any, xiithpassyear: any, xiithcoresubject: any, xiithpercentage: any, collegeMap: any, idb: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/saveED",
            {
                id: idb,
                xthInstitutionName: xthinstitute,
                xthPassingYear: xthpassyear,
                xthboard: xthboard,
                xthPassPercentage: xthpercentage,
                institutionName: xiithinstitute,
                passingYear: xiithpassyear,
                coreSubject: xiithcoresubject,
                passPercentage: xiithpercentage,
                institutions: collegeMap,
                statusFlag: status
            })
        .then((response) => {
            console.log("res---------->", response);
            return response;
        })
        .catch((error) => {
            console.log("err---------->", error);
            return error;
        });
};

const EmployeeEmployementSaveOrUpdate = (idb: any, employmentDetailMap: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/saveED",
            {
                id: idb,
                employmentDetails: employmentDetailMap,
                statusFlag: status
            })
        .then((response) => {
            console.log("res---------->", response);
            return response;
        })
        .catch((error) => {
            console.log("err---------->", error);
            return error;
        });
};

const EmployeeSkillSaveOrUpdate = (techskillMap: any, idb: any, certificateMap: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/saveED",
            {
                id: idb,
                skillsDetails: techskillMap,
                certificates: certificateMap,
                statusFlag: status
            })
        .then((response) => {
            console.log("res---------->", response);
            return response;
        })
        .catch((error) => {
            console.log("err---------->", error);
            return error;
        });
};

const EmployeeIdentiteSaveOrUpdate = (panNo: any, passport: any, aadhaar: any, passportValidity: any, idb: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/saveED",
            {
                id: idb,
                passport: passport,
                pan: panNo,
                passportValidity: passportValidity,
                aadhaar: aadhaar,
                statusFlag: status
            })
        .then((response) => {
            console.log("res---------->", response);
            return response;
        })
        .catch((error) => {
            console.log("err---------->", error);
            return error;
        });
};

const EmployeeStatutorySaveOrUpdate = (pfNo: any, esiNo: any, insurance: any, insuranceValidity: any, coverage: any, idb: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/saveED",
            {
                id: idb,
                pfNo: pfNo,
                esiNo: esiNo,
                groupInsurance: insurance,
                insuranceValidity: insuranceValidity,
                insuranceCoverages: coverage,
                statusFlag: status
            })
        .then((response) => {
            console.log("res---------->", response);
            return response;
        })
        .catch((error) => {
            console.log("err---------->", error);
            return error;
        });
};

const EmployeeDetailsSaveOrUpdate = (business: any, department: any, reportingPerson: any, idb: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("employeeDetails/saveED",
            {
                id: idb,
                businessUnit: business,
                masterDepartment: department,
                reportingManager: [reportingPerson],
                statusFlag: status
            })
        .then((response) => {
            console.log("res---------->", response);
            return response;
        })
        .catch((error) => {
            console.log("err---------->", error);
            return error;
        });
};

const GetAllBussinessunitName = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("businessUnit/getAllBusinessUnits")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const GetAllEmployeeNameDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/names")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
// const GetAllEmployeeByManager = () => {
//     const api = axios.create({
//         baseURL: API_URL,
//     });
//     return api.get("employeeDetails/managerList")
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//             console.log("Error");
//             return error;
//         });
// }
const GetAllEmployeeByManagers = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/managerList?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const ViewBusinessUnitById = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("businessUnit/businessUnitById?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const UpdateBusinessUnit = (id: any, businessName: any, businessCode: any, businessHead: any, businessAlternate: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("businessUnit/saveUpdateBusinessUnit",
        {
            id: id,
            businessUnitName: businessName,
            businessUnitCode: businessCode,
            businessUnitHead: businessHead,
            businessUnitAlternate: businessAlternate
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const CreateBusinessUnit = (unitName: any, unitCode: any, unitHead: any, unitAlter: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("businessUnit/saveUpdateBusinessUnit",
        {
            businessUnitName: unitName,
            businessUnitCode: unitCode,
            businessUnitHead: unitHead,
            businessUnitAlternate: unitAlter,
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetallMasterDepartment = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("masterDepartment/getAllMasterDepartments")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const CreateDepartmentUnit = (Dname: any, Dcode: any, Dhead: any, Dalter: any, Bname: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("masterDepartment/saveUpdateMasterDepartment",
        {
            businessUnitId: Bname,
            departmentName: Dname,
            departmentCode: Dcode,
            departmentHead: Dhead,
            departmentAlternate: Dalter
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ViewDepartmentUnitById = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("masterDepartment/masterDepartmentById?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const UpdateDepartmentUnit = (id: any, DepartName: any, DepartCode: any, Departhead: any, Departalter: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("masterDepartment/saveUpdateMasterDepartment",
        {
            id: id,
            departmentName: DepartName,
            departmentCode: DepartCode,
            departmentHead: Departhead,
            departmentAlternate: Departalter
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const CreateClient = (ClientName: any, contactName: any, contactNo: any, contactEmail: any, GST: any, companyAddress: any, crtBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("clientinfo/hr/saveupdate",
        {
            clientName: ClientName,
            contactName: contactName,
            contactNo: contactNo,
            contactEmail: contactEmail,
            gst: GST,
            companyAddress: companyAddress,
            createdBy: crtBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const CreateDesignation = (designname: any, designdescrip: any, crtby: any, updtby: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("Designations/saveUpdateDesignation",
        {
            designationName: designname,
            designationDescription: designdescrip,
            createdBy: crtby,
            updatedBy: updtby
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ViewDesignationById = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("Designations/designationById?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const UpadateDesignation = (id: any, name: any, desc: any, upBy: any) => {
    console.log("updated data", name, id, desc)
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("Designations/saveUpdateDesignation",
        {
            id: id,
            designationName: name,
            designationDescription: desc,
            // createdBy:crtBy ,
            updatedBy: upBy
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const UpdateClient = (Id: any, cname: any, contactname: any, contactno: any, contactemail: any, gst: any, address: any, updatedBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("clientinfo/hr/saveupdate",
        {
            id: Id,
            clientName: cname,
            contactName: contactname,
            contactNo: contactno,
            contactEmail: contactemail,
            company_Address: address,
            gst: gst,
            updatedBy: updatedBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ViewClientById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("clientinfo/hr/getclientbyid?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetAllClientNameDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get('clientinfo/hr/names')
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const CreateProject = (pname: any, fromDate: any, toDate: any, projectDescription: any, client: any, createdBy: any, bussinessUnit: any, departmentUnit: any, projectManager: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/hr/saveupdate",
        {
            projectName: pname,
            fromDate: fromDate,
            todate: toDate,
            projectDescription: projectDescription,
            client: client,
            createdBy: createdBy,
            businessUnitId: bussinessUnit,
            masterDepartmentId: departmentUnit,
            projectManager: projectManager,

        }
    )
        .then((response) => {
            console.log(pname)
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetProjectById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/hr/getprojectbyid?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const GetHistoryProjectById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/projectInfo?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const UpdateProject = (id: any, pname: any, clientName: any, fromDate: any, toDate: any, projectDes: any, updatedBy: any, updateBussinessUnit: any, updateDepartmentUnit: any, updateProjectManager: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/hr/saveupdate",
        {
            id: id,
            projectName: pname,
            fromDate: fromDate,
            todate: toDate,
            client: clientName,
            projectDescription: projectDes,
            updatedBy: updatedBy,
            businessUnitId: updateBussinessUnit,
            masterDepartmentId: updateDepartmentUnit,
            projectManager: updateProjectManager,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetAllEmployeeNames = (Id: any, empId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/unmappedEmp?id=" + Id + "&empId=" + empId)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetProjectAssignedListById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/hr/updatelist?id=" + Id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const AssignProjectResource = (project: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/hr/assignemp",
        {
            projectEmployeeDtos: project
        }
    )
        .then((response) => {
            console.log()
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetallProject = (id: any, statusId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/hr/getall?id=" + id + "&statusId=" + statusId)
        // return api.get("timelog/employee?fromDate=" + fromDate + "&toDate=" + toDate + "&empCode=" + createdBy)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetallMyDepartment = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("masterDepartment/byUnitHead?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ViewClientList = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("clientinfo/hr/getall"
    )
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const ViewMyDepartment = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("masterDepartment/project?id=" + id
    )
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const GetAllMemberTimeLog = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/getall")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const MemberTimeLogDelete = (Id2: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/deletebyid?id=" + Id2)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const MemberTimeLogViewById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/getbyid?id=" + Id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const MemberTimeLogSave = (id: any, logdate: any, empCode: any, timeloglist: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    if (id === "") {
        return api.post("timelog/savetimelog",
            {
                date: logdate,
                employeeId: empCode,
                timeLogList: timeloglist,
                status: status,
            }
        )
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    }
    else {
        return api.post("timelog/savetimelog",
            {
                id: id,
                date: logdate,
                employeeId: empCode,
                timeLogList: timeloglist,
                status: status,
            }
        )
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    }
}

const TimelogGetProjectNameById = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/getbyEmp?id=" + id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}

const GetAllEmployeeTimeSheet = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/employee?id=" + Id)
        .then((res) => {
            // console.log()
            return res;
        })
        .catch((error) => {
            // console.log(dd);
            return error;
        });
};

const ViewEmployeeTimeSheetById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/getbyid?id=" + Id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const TimelogGetinTimeSheet = (fromDate: any, toDate: any, createdBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/employee?fromDate=" + fromDate + "&toDate=" + toDate + "&empCode=" + createdBy)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const TimesheetSave = (empCode: any, month: any, week: any, fromDate: any, toDate: any, des: any, timeloglist: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("timesheet/saveupdate",
        {
            empId: empCode,
            month: month,
            week: week,
            fromDate: fromDate,
            toDate: toDate,
            description: des,
            timeLogs: timeloglist,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ManagerGetAllTeams = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/manager?id=" + Id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const ManagerGetAllLeaveApproval = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/approval?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetLeaveDetailsById = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/id?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};

const GetLeaveStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/leaveStatusList")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
};

const LeaveApproveByManager = (id: any, status: any, leaveType: any, fdate: any, tdate: any, reason: any, reporting: any, noOfDays: any, employeeCode: any, remarks: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("leaveDetails/saveUpdateLeave",
        {
            id: id,
            leaveStatus: status,
            leaveType: leaveType,
            reason: reason,
            empCode: employeeCode,
            fromDate: fdate,
            toDate: tdate,
            noOfDays: noOfDays,
            remarks: remarks,
            status: true
        }
    )
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};

const ManagerGetTimesheetById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/approval?id=" + Id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const TimeSheetStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/timeStatus")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const TimeSheetCreateStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/status")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const ManagerTimesheetApprove = (Id: any, fromDate: any, toDate: any, des: any, hours: any, status: any, responseby: any, feedback: any, idlist: any, month: any, week: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("timesheet/saveupdate",
        {
            id: Id,
            fromDate: fromDate,
            todate: toDate,
            description: des,
            totalhours: hours,
            status: status,
            respondedBy: responseby,
            feedback: feedback,
            timeLogs: idlist,
            month: month,
            week: week,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const ChangePassword = (Id: any, oldpassword: any, newpassword: any, confrimNewpassword: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("employeeDetails/changePassword",
        {
            id: Id,
            oldPassword: oldpassword,
            newPassword: newpassword,
            confirmPassword: confrimNewpassword
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const GetTimelogListByEmpCode = (empCode: any) => {

    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/emptimelog?id=" + empCode)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const ActivityGetAll = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("activitymeta/all")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}

const ActivitySaveOrUpdate = (activity: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("activecode/saveandupdate",
        {
            activityCodes: activity,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const GetActivityCodeByProjectId = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("activecode/byproject?id=" + id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}

const GetActivityListByProjectId = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("activecode/name?id=" + id)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}

const ActivityMetaSave = (parentActivity: any, activityMeta: any, activityDescription: any, createdBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("activitymeta/save",
        {
            parentActivityId: parentActivity,
            activityMeta: activityMeta,
            activityMetaDescription: activityDescription,
            createdBy: createdBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const GetLeaveApprovalStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/status")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}

const GetTimeSheetReport = (fromDate: any, toDate: any, projectId: any, monthName: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/pdf?fromDate=" + fromDate + "&toDate=" + toDate + "&projectId=" + projectId,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        })
        .then((response) => {
            console.log(response)
            if (response.data.byteLength != 0) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', monthName + '_Log_Report.pdf');
                document.body.appendChild(link);
                link.click();
            }
            else {
                swal("", "No Records", "error")
            }
        })
        .catch((error) => console.log(error));
}

const LeaveBatchUpdate = (month: any, createBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("batchProcess/leave", {
        month: month,
        // employmentType:Emptype,
        createdBy: createBy
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const GetEmployeeLeaveHistory = (fromDate: any, toDate: any, Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    if (fromDate === "" && toDate === "") {
        return api.get("leaveDetails/date?id=" + Id)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    }
    else {
        return api.get("leaveDetails/date?fromDate=" + fromDate + "&toDate=" + toDate + "&id=" + Id)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    }

}

const CreateTimeLogStatusDropDown = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/status")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

const GetDropDownBusinessUnitOnProject = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    if (id == "all") {
        Url = "businessUnit/getAllBusinessUnits"
    } else {
        Url = "businessUnit/list?id=" + id
    }
    return api.get(Url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const GetAllDepartmentUnitDropDownOnProject = (Id: any, empId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("masterDepartment/unitAndDept?unitId=" + Id + "&id=" + empId)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetAllParentActivity = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("parentActivity/all")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const ParentActivitySave = (activity: any, activityDescription: any, createdBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("parentActivity/save",
        {
            parentActivity: activity,
            parentActivityDesc: activityDescription,
            createdBy: createdBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}

const GetParentActivityById = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("parentActivity/id?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const GetActivityCodeByParentId = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("activitymeta/parent?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const GetParentsorting = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    if (id == "all") {
        Url = "activitymeta/all"
    } else {
        Url = "activitymeta/parent?id=" + id
    }
    return api.get(Url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const Remove = (employeeId: any, projectId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/removeEmp?empId=" + employeeId + "&projectId=" + projectId)
        .then((response) => {
            return response;
        })

        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const GetAllEmployeeFilterByBu = (id: any, projectId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/inUnit?id=" + id + "&projectId=" + projectId)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const SearchEmployeeByBussinessUnit = (createdBy: any, businessUnit: any, id: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    const name = localStorage.getItem('UserRole');

    if (name === 'ADMIN') {
        if (id == "all") {
            Url = "employeeDetails/getAllEmployDetailsList" + "&status=" + status
        } else if (businessUnit === "all") {
            Url = "employeeDetails/manager?id=" + createdBy + "&status=" + status
        }

        else {
            Url = "employeeDetails/manager?id=" + createdBy + "&businessUnit=" + businessUnit + "&department=" + id + "&status=" + status
        }
    } else if (name === 'BUSINESS_UNIT_HEAD') {
        if (id == "all") {
            Url = 'employeeDetails/manager?id=' + createdBy

        }
        else if (businessUnit === "all") {
            Url = "employeeDetails/manager?id=" + createdBy
        }
        else {
            Url = "employeeDetails/manager?id=" + createdBy + "&businessUnit=" + businessUnit + "&department=" + id + "&status=" + status
        }
    }

    // if  (id == "all") {
    //     Url = "employeeDetails/getAllEmployDetailsList"
    // } else if (businessUnit === "all") {
    //     Url = "employeeDetails/manager?id=" + createdBy
    // }
    // else {
    //     Url = "employeeDetails/manager?id=" + createdBy + "&businessUnit=" + businessUnit + "&department=" + id
    // }
    return api.get(Url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const EffortUtilize = (createdBy: any, businessUnit: any, id: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    const name = localStorage.getItem('UserRole');

    if (name === 'ADMIN') {
        if (id == "all") {
            Url = "employeeDetails/getAllEmployDetailsList" + "&status=" + status
        } else if (businessUnit === "all") {
            Url = "employeeDetails/manager?id=" + createdBy + "&status=" + status
        }

        else {
            Url = "employeeDetails/managersEffortUtilization?id=" + createdBy + "&businessUnit=" + businessUnit + "&department=" + id + "&status=" + status
        }
    } else if (name === 'BUSINESS_UNIT_HEAD') {
        if (id == "all") {
            Url = 'employeeDetails/manager?id=' + createdBy

        }
        else if (businessUnit === "all") {
            Url = "employeeDetails/manager?id=" + createdBy
        }
        else {
            Url = "employeeDetails/managersEffortUtilization?id=" + createdBy + "&businessUnit=" + businessUnit + "&department=" + id + "&status=" + status
        }
    }

    // if  (id == "all") {
    //     Url = "employeeDetails/getAllEmployDetailsList"
    // } else if (businessUnit === "all") {
    //     Url = "employeeDetails/manager?id=" + createdBy
    // }
    // else {
    //     Url = "employeeDetails/manager?id=" + createdBy + "&businessUnit=" + businessUnit + "&department=" + id
    // }
    return api.get(Url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const GetBusinessunitEmployee = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .get("businessUnit/list?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const TimeSheetResubmit = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .post("timesheet/resubmit?id=" + id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error:", error);
            return error;
        });
};
const Timesheethistory = (id: any, month: any) => {

    var link: any;

    if (month != "" && month != null) {
        link = "timesheet/report?id=" + id + "&month=" + month
    }
    else {
        link = "timesheet/report?id=" + id
    }
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get(link)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const EmployeeTimesheetPending = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .get("timesheet/pending?id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const EmployeeGeneratePdf = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear().toString();

    const formattedDate = `${day}-${month}-${year}`;
    // const formattedDate = currentDate.toISOString().slice(0, 10);
    return api.get("timesheet/pendingReport?id=" + Id, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        }
    })
        .then((response) => {
            console.log(response)
            if (response.data.byteLength != 0) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Timesheet Pending Approval Report _${formattedDate}.pdf`);
                document.body.appendChild(link);
                link.click();
            }
            else {
                alert("No DATA FOUND !");
            }

        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

// const MissingEmployee = (Id: any, month: any, sortOrder: any) => {
//     const api = axios.create({
//         baseURL: API_URL,
//     });
//     return api.get("timesheet/missing?id=" + Id + "&month=" + month +"&sortOrder=" + sortOrder)
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//             return error;
//         });
// }
const MissingEmployee = (Id: any, month: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/missing?id=" + Id + "&month=" + month)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}
const MissingEmployeePdf = (Id: any, month: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    const date = new Date(month);
    const formattedMonth = `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;

    return api.get("timesheet/missingReport?id=" + Id + "&month=" + month, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        }
    })
        .then((response) => {
            console.log(response)
            if (response.data.byteLength !== 0) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Missing Timesheet Report_${formattedMonth}.pdf`);
                document.body.appendChild(link);
                link.click();
            } else {
                alert("No DATA FOUND !");
            }
            // return response;
        })
        .catch((error) => {
            return error;
        });
}


// const TimelogGetinTimeSheet = (fromDate: any, toDate: any, createdBy: any) => {
//     const api = axios.create({
//         baseURL: API_URL,
//     });
//     return api.get("timelog/employee?fromDate=" + fromDate + "&toDate=" + toDate + "&empCode=" + createdBy)
//         .then((res) => {
//             return res;
//         })
//         .catch((error) => {
//             return error;
//         });
// };
const WeekList = (fromDate: any, toDate: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timesheet/month?fromDate=" + fromDate + "&toDate=" + toDate)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
}
const ProjectReport = (projectId: any, projectResource: any, activity: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        // &projectResource=2&activity=2
        .get("projectinfo/report?id=" + projectId + "&projectResource=" + projectResource + "&activity=" + activity)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const ProjectReportPdf = (projectId: any, projectResource: any, activity: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/projectEffort?id=" + projectId + "&projectResource=" + projectResource + "&activity=" + activity, {},
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        }
    )
        .then((response) => {
            console.log(response)
            // if (response.data.byteLength != 0) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "" + 'Project Report.pdf');
            document.body.appendChild(link);
            link.click();
            // }
            // else {
            //     alert("No DATA FOUND !");
            // }

        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}


const Clientlist = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("clientinfo/byrole?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            return error;
        });
};

const Clientproject = (id: any, createdBy: any, projectStatusId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/client?id=" + id + '&empId=' + createdBy + "&statusId=" + projectStatusId)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            return error;
        });
};
//
const Pdfgenerate = (obj: any, clientname: any, monthname: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/clientpdf?", obj,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        })
        .then((response) => {
            console.log(response)
            if (response.data.byteLength != 0) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', monthname + "_" + clientname + "_" + 'Log_Report.pdf');
                document.body.appendChild(link);
                link.click();
            }
            else {
                alert("No DATA FOUND !");
            }

        })
        .catch((error) => console.log(error));
}
const TransferEmployee = (id: any, employees: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("employeeDetails/updateReportingManager",
        {
            id: id,
            employees: employees
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const RemoveTimelogs = (ids: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("timelog/remove?id=" + ids,

    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const EmployeeExit = (empCode: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/byEmployeeCode?employeeCode=" + empCode)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const EmployeeResign = (employeeCode: any, employeeName: any, businessUnit: any, masterDepartment: any, reportingManager: any, dateOfLeaving: any, dateOfResignation: any, reason: any, createdBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("employeeDetails/resign",
        {
            employeeCode: employeeCode,
            employeeName: employeeName,
            businessUnit: businessUnit,
            masterDepartment: masterDepartment,
            reportingManager: reportingManager,
            dateOfLeaving: dateOfLeaving,
            dateOfResignation: dateOfResignation,
            reason: reason,
            createdBy: createdBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const Excelgenerate = (obj: any, clientname: any, monthname: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/clientExcel?", obj,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then((response) => {
            console.log(response)


            if (response.data.byteLength !== 0) {

                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });


                saveAs(blob, `${monthname}_${clientname}_Log_Report.xlsx`);
            } else {
                alert("No DATA FOUND !");
            }
        })
        .catch((error) => console.log(error));
}

const EmployeePdfgenerate = (obj: any, clientname: any, monthname: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/consolReport?", obj,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        })
        .then((response) => {
            console.log(response)
            if (response.data.byteLength != 0) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', monthname + "_" + clientname + "_" + 'Log_Report.pdf');
                document.body.appendChild(link);
                link.click();
            }
            else {
                alert("No DATA FOUND !");
            }

        })
        .catch((error) => console.log(error));
}
const GeneralActivity = (projectId: any, activityMetaIds: any, createdBy: any,) => {
    console.log(projectId)
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("activecode/assignGeneral",
        {
            projectId: projectId,
            activityMetaIds: activityMetaIds,
            createdBy: createdBy,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const ProjectInherit = (lastCreatedProjectId: any, selectedActivityCodes: any, createdBy: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("activecode/inherit",
        {
            projectId: lastCreatedProjectId,
            activityCodes: selectedActivityCodes
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const GetGeneralActivity = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("activitymeta/general")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}
const LeaveReport = (businessUnitId: any, fromDate: any, toDate: any, leaveTypeId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    if (leaveTypeId == "all" && businessUnitId == "all") {
        Url = "leaveDetails/report?businessUnitId=" + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId="
    }
    else if (leaveTypeId == "all") {
        Url = "leaveDetails/report?businessUnitId=" + businessUnitId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId="
    }
    else if (businessUnitId == "all") {
        Url = "leaveDetails/report?businessUnitId=" + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId=" + leaveTypeId
    }
    else {
        Url = "leaveDetails/report?businessUnitId=" + businessUnitId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId=" + leaveTypeId
    }
    return api.get(Url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
// const LeaveReport = (businessUnitId: any, fromDate: any, toDate: any,leaveTypeId:any) => {
//     const api = axios.create({
//         baseURL: API_URL,
//     });
//     return api
//         .get("leaveDetails/report?businessUnitId=" + businessUnitId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId=" + leaveTypeId)
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//             console.log("Error");
//             return error;
//         });
// }
const LeaveReportPdf = (businessUnitId: any, fromDate: any, toDate: any, leaveTypeId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    if (leaveTypeId == "all" && businessUnitId == "all") {
        Url = "leaveDetails/pdf?businessUnitId=" + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId="
    }
    else if (leaveTypeId == "all") {
        Url = "leaveDetails/pdf?businessUnitId=" + businessUnitId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId="
    }
    else if (businessUnitId == "all") {
        Url = "leaveDetails/pdf?businessUnitId=" + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId=" + leaveTypeId
    }
    else {
        Url = "leaveDetails/pdf?businessUnitId=" + businessUnitId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&leaveTypeId=" + leaveTypeId
    }
    return api
        .get(Url,
            {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            }
        )
        .then((response) => {
            console.log(response)
            if (response.data.byteLength != 1124) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "" + 'LeaveDetails_Report.pdf');
                document.body.appendChild(link);
                link.click();
            }
            else {
                swal("", "No Leave Records in the selected date range !!!", "error")
            }

        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const Dashboard = (Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api
        .get("HrDashboard/byRole?id=" + Id)
        .then((response) => {
            return response;

        })
        .catch((error) => {
            console.log("Error:", error);
            return error;
        });
};

const Birthdaylist = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/birthday?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const Pendingconfirm = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/confirm?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const MissingTime = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/timesheet?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const Todaysabsent = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/todayLeave?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const Pendingleave = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/leaveApproval?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const EmpProjectDash = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/projectEffort?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const MissingTimesheetdash = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/memberMissingTimesheet?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const EmployeeDashboard = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/memberDashboard?id=" + id)
        .then((response) => {
            console.log(id)
            return response;
        })
        .catch((error) => {
            console.log(id);
            return error;
        });
};
const PrjClsCheckResource = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/checkAssignResource?id=" + id)
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};
const GetPrjClsStatuslist = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/allStatus")
        .then((res) => {
            // console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};
const ProjectClosure = (projectId: any, projectStatusId: any, remarks: any, createdBy: any, closedBy: any) => {
    // console.log(projectId)
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("projectinfo/saveClosure",
        {
            projectId: projectId,
            projectStatusId: projectStatusId,
            remarks: remarks,
            createdBy: createdBy,
            closedBy: closedBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const ResourceEffort = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/resourceEffort?id=" + id)
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};
const ResourceEffortPdf = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("timelog/resourceEffortPdf?id=" + id,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        }
    )
        .then((response) => {
            console.log(response)
            // if (response.data.byteLength != 0) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "" + 'ResourceEffort Report.pdf');
            document.body.appendChild(link);
            link.click();
            // }
            // else {
            //     alert("No DATA FOUND !");
            // }

        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}

const Holiday = (year: any, empid: any, type: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("holiday/all?year=" + year + "&empId=" + empid + "&type=" + type)
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};

const Leaveadd = (date: any, description: any, holidayType: any, createdBy: any,) => {
    // console.log(projectId)
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("holiday/save",
        {
            "date": date,
            "holidayDescription": description,
            "holidayType": holidayType,
            "createdBy": createdBy,
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const DeleteLeave = (id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("holiday/delete?id=" + id)
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};
const NumberLeave = (fDate: any, tDate: any, empCode: any, leaveId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/validateDays?fromDate=" + fDate + '&toDate=' + tDate + "&empCode=" + empCode + "&leaveType=" + leaveId)
        .then((response) => {

            return response;
        })
        .catch((error) => {
            return error;
        });
};
const updateNumberLeave = (fDate: any, tDate: any, empCode: any, leaveId: any, leave: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/validateDays?fromDate=" + fDate + '&toDate=' + tDate + "&empCode=" + empCode + "&leaveType=" + leaveId + "&leaveId=" + leave)
        .then((response) => {

            return response;
        })
        .catch((error) => {
            return error;
        });
};
const EmpConfirm = (empcode: any, empnames: any, businessunit: any, departmentunit: any, dateofconfirm: any, confirmappraisal: any, note: any, createdBy: any) => {

    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("employeeDetails/confirmation",
        {
            employeeCode: empcode,
            employeeName: empnames,
            businessUnit: businessunit,
            masterDepartment: departmentunit,
            dateOfConfirmation: dateofconfirm,
            confirmationApproveRequestOn: confirmappraisal,
            note: note,
            createdBy: createdBy
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const Employeeconfirmcode = (empCode: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("employeeDetails/empCode?employeeCode=" + empCode)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const GetCompoffstatus = () => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/allStatus")
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
}
const Compoffsave = (empid: any, workdate: any, reason: any, statusid: any, date: any, status: any) => {

    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("compoff/saveOrUpdate",
        {

            employeeId: empid,
            workedOnDate: workdate,
            reason: reason,
            compOffStatus: {
                id: statusid
            },
            compOffDate: date,
            status: status
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const CompoffApply = (selectedCompOffId: any, empid: any, workdate: any, reason: any, statusid: any, date: any, status: any) => {

    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("compoff/saveOrUpdate",
        {
            id: selectedCompOffId,
            employeeId: empid,
            workedOnDate: workdate,
            reason: reason,
            compOffStatus: {
                id: statusid
            },
            compOffDate: date,
            status: status
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const Compoffupdate = (Ids: any, empid: any, workdate: any, reason: any, remark: any, updatecompoff: any, dateview: any, status: any) => {

    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("compoff/saveOrUpdate",
        {
            id: Ids,
            employeeId: empid,
            workedOnDate: workdate,
            reason: reason,
            remarks: remark,
            compOffStatus: {
                id: updatecompoff
            },
            compOffDate: dateview,
            status: status
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const Compoffdelete = (Ids: any, empid: any, workdate: any, reason: any, date: any, status: any) => {

    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("compoff/saveOrUpdate",
        {
            id: Ids,
            employeeId: empid,
            workedOnDate: workdate,
            reason: reason,
            compOffStatus: {
                id: ''
            },
            compOffDate: date,
            status: status
        }
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};
const Compoffbalance = (empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/balance?id=" + empid)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const Compoffgetall = (empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/all?id=" + empid)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const CompoffApproval = (empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/approval?id=" + empid)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const CompoffReport = (businessUnitId: any, fromDate: any, toDate: any, empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    // if( businessUnitId == "all" ){
    //     Url = "leaveDetails/report?businessUnitId="  + "&fromDate=" + fromDate + "&toDate=" + toDate 
    // }
    if (businessUnitId == "all") {
        Url = "compoff/report?id=" + empid + "&fromDate=" + fromDate + "&toDate=" + toDate + "&businessUnit=" + ""
    }
    else {
        Url = "compoff/report?id=" + empid + "&fromDate=" + fromDate + "&toDate=" + toDate + "&businessUnit=" + businessUnitId
    }
    return api.get(Url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const CompoffReportPdf = (businessUnitId: any, fromDate: any, toDate: any, empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    var Url: any;
    if (businessUnitId == "all") {
        Url = "compoff/pdf?id=" + empid + "&fromDate=" + fromDate + "&toDate=" + toDate + "&businessUnit=" + ""
    }
    else {
        Url = "compoff/pdf?id=" + empid + "&fromDate=" + fromDate + "&toDate=" + toDate + "&businessUnit=" + businessUnitId
    }
    return api
        .get(Url,
            {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            }
        )
        .then((response) => {
            console.log(response)
            if (response.data.byteLength != 1124) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "" + 'Compoff_Report.pdf');
                document.body.appendChild(link);
                link.click();
            }
            else {
                swal("", "No Compoff Records in the selected date range !!!", "error")
            }

        })
        .catch((error) => {
            console.log("Error");
            return error;
        });
}
const Compoffdashboard = (empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("HrDashboard/compOffApproval?id=" + empid)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const CompoffRegister = (empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/regApproval?id=" + empid)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const CompoffApplyleave = (empid: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/leaveApproval?id=" + empid)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};
const Compoffdatecheck = (id: any, date: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("compoff/dateValidation?date=" + date + "&id=" + id)
        .then((res) => {
            console.log(res)
            return res;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
};
const EmployeeLeaveUpdate = (fromDate: any, toDate: any, Id: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("leaveDetails/byDateAndEmployee?fromDate=" + fromDate + "&toDate=" + toDate + "&id=" + Id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

}

const EmployeeUpdateview = (id: any, noofdays: any, fromDate: any, toDate: any, leaveType: any, reason: any, leavestatus: any, empCode: any, status: any,) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("leaveDetails/updateByAdmin",
        {
            "id": id,
            "noOfDays": noofdays,
            "fromDate": fromDate,
            "toDate": toDate,
            "leaveType": leaveType,
            "reason": reason,
            "leaveStatus": leavestatus,
            "empCode": empCode,
            "status": true
        }
    )
        .then((response) => {
            console.log(response)
            return response;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
}
const EmployeeUpdatecancel = (id: any, noofdays: any, fromDate: any, toDate: any, leaveType: any, reason: any, sts: any, empCode: any, status: any,) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.post("leaveDetails/updateByAdmin",
        {
            "id": id,
            "noOfDays": noofdays,
            "fromDate": fromDate,
            "toDate": toDate,
            "leaveType": leaveType,
            "reason": reason,
            "leaveStatus": sts,
            "empCode": empCode,
            "status": false
        }
    )
        .then((response) => {
            console.log(response)
            return response;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
}
const Employeeassign = (projectId: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });
    return api.get("projectinfo/AssignedEmployee?projectId=" + projectId)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

}

const EmployeeEffortPdf = async (projectId: any, fromDate: any, toDate: any, selectedIds: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });

    try {
        const response = await api.post(`timelog/detailedReportPdf?projectId=${projectId}&fromDate=${fromDate}&toDate=${toDate}`,
            selectedIds,
            {
                responseType: 'blob' // Important for handling PDF data
            }
        );

        // Check if the response data is not empty
        if (response.data.size > 0) {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Timelog_Detail_Report.pdf');
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Return an object with status
            return { status: '200' };
        } else {
            return { status: '404', message: 'No DATA FOUND!' };
        }
    } catch (error) {
        console.error('Error:', error);
        return { status: '500', message: 'An error occurred while generating the report.' };
    }
};

const EmployeeExcel = async (projectId: any, fromDate: any, toDate: any, selectedIds: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });

    try {
        const response = await api.post(`timelog/detailedReportExcel?projectId=${projectId}&fromDate=${fromDate}&toDate=${toDate}`,
            selectedIds,
            {
                responseType: 'blob' // Important for handling PDF data
            }
        );

        // Check if the response data is not empty
        if (response.data.size > 0) {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Timelog_Detail_Report.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Return an object with status
            return { status: '200' };
        } else {
            return { status: '404', message: 'No DATA FOUND!' };
        }
    } catch (error) {
        console.error('Error:', error);
        return { status: '500', message: 'An error occurred while generating the report.' };
    }
};

const EmployeeLeavePdf = async (bussinessUnitId: any, departmentId: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });

    try {
        let url = `leaveDetails/balancePdfReport?`;

        if (bussinessUnitId) {
            url += `businessUnitId=${bussinessUnitId}&`;
        }

        if (departmentId) {
            url += `departmentId=${departmentId}&`;
        }

        if (status) {
            url += `status=${status}&`;
        }

        url = url.slice(0, -1);

        const response = await api.get(url, {
            responseType: 'blob',
        });

        // Check if the response data is not empty
        if (response.data.size > 0) {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Leave_Balance_Report.pdf');
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Return an object with status
            return { status: '200' };
        } else {
            return { status: '404', message: 'No DATA FOUND!' };
        }
    } catch (error) {
        console.error('Error:', error);
        return { status: '500', message: 'An error occurred while generating the report.' };
    }
};

const EmployeeLeaveExcel = async (bussinessUnitId: any, departmentId: any, status: any) => {
    const api = axios.create({
        baseURL: API_URL,
    });

    try {

        let url = `leaveDetails/balanceExcelReport?`;

        if (bussinessUnitId) {
            url += `businessUnitId=${bussinessUnitId}&`;
        }

        if (departmentId) {
            url += `departmentId=${departmentId}&`;
        }

        if (status) {
            url += `status=${status}&`;
        }

        url = url.slice(0, -1);

        const response = await api.get(url, {
            responseType: 'blob',
        });

        // Check if the response data is not empty
        if (response.data.size > 0) {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Leave_Balance_Report.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Return an object with status
            return { status: '200' };
        } else {
            return { status: '404', message: 'No DATA FOUND!' };
        }
    } catch (error) {
        console.error('Error:', error);
        return { status: '500', message: 'An error occurred while generating the report.' };
    }
};
const EffortUtilizereport = async (
    fromDate: any,
    toDate: any,
    selectedIds: any,
    business: any,
    department: any
) => {
    const api = axios.create({
        baseURL: API_URL,
    });

    try {
        const response = await api.post(
            `timelog/effortUtilizationReportPdf?fromDate=${fromDate}&toDate=${toDate}&bussinessUnit=${business}&department=${department}`,
            selectedIds,
            {
                responseType: 'blob',
                validateStatus: (status) => status >= 200 && status < 500,
            }
        );

        console.log(response.status, 'HTTP Status');

        if (response.status === 204) {
            return { status: '204' };
        }

        if (response.status === 200) {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Effort_Utilization_Report.pdf');
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return { status: '200' };
        }

        // Any other status
        return { status: String(response.status), message: 'Unexpected response' };
    } catch (error: any) {
        console.error('Error:', error);
        return { status: '500', message: 'An error occurred while generating the report.' };
    }
};



const service = {
    Login,
    HRDashBoardGetAllEmploye,
    HRDashBoardGetAllClient,
    HRDashBoardGetAllProject,
    HRDashBoardGetTodayLeave,
    HRViewEmployee,
    HRUpdateEmployee,
    ViewLeaveCount,
    ApplyLeave,
    GetLeaveType,
    HRGetAllApproval,
    getEmployementTypeList,
    GetEmployeTypeViewId,
    UpdateEmployeeType,
    CreateEmployeeType,
    ViewEmpolyeeById,
    GetAllGenderDropDown,
    AllBloodGroupsDropDown,
    GetAllMaritalStatusDropDown,
    GetEmployeeCategoryDropDown,
    GetAllEMployeeStatusDropDown,
    GetAllDesignationDropDown,
    GetAllReportingManagerDropDown,
    GetAllBusinessUnitDropDown,
    GetAllDepartmentUnitDropDown,
    ViewAllProficiencyDropDown,
    ViewAllBoardDropDown,
    EmployeePersonalSaveOrUpdate,
    EmployeeEducationalSaveOrUpdate,
    EmployeeEmployementSaveOrUpdate,
    EmployeeSkillSaveOrUpdate,
    EmployeeIdentiteSaveOrUpdate,
    EmployeeStatutorySaveOrUpdate,
    EmployeeDetailsSaveOrUpdate,
    GetAllBussinessunitName,
    GetAllEmployeeNameDropDown,
    ViewBusinessUnitById,
    UpdateBusinessUnit,
    CreateBusinessUnit,
    GetallMasterDepartment,
    CreateDepartmentUnit,
    ViewDepartmentUnitById,
    UpdateDepartmentUnit,
    CreateClient,
    CreateDesignation,
    ViewDesignationById,
    UpadateDesignation,
    UpdateClient,
    ViewClientById,
    GetAllClientNameDropDown,
    CreateProject,
    GetProjectById,
    UpdateProject,
    GetAllEmployeeNames,
    GetProjectAssignedListById,
    AssignProjectResource,
    GetallProject,
    ViewClientList,
    GetAllMemberTimeLog,
    MemberTimeLogDelete,
    MemberTimeLogViewById,
    TimelogGetProjectNameById,
    MemberTimeLogSave,
    GetAllEmployeeTimeSheet,
    ViewEmployeeTimeSheetById,
    TimelogGetinTimeSheet,
    TimesheetSave,
    ManagerGetAllTeams,
    ManagerGetAllLeaveApproval,
    GetLeaveDetailsById,
    GetLeaveStatusDropDown,
    LeaveApproveByManager,
    ManagerGetTimesheetById,
    TimeSheetStatusDropDown,
    ManagerTimesheetApprove,
    ChangePassword,
    GetTimelogListByEmpCode,
    ActivityGetAll,
    ActivitySaveOrUpdate,
    GetActivityCodeByProjectId,
    GetActivityListByProjectId,
    ActivityMetaSave,
    GetLeaveApprovalStatusDropDown,
    GetTimeSheetReport,
    LeaveBatchUpdate,
    GetEmployeeLeaveHistory,
    CancelLeave,
    CreateTimeLogStatusDropDown,
    TimeSheetCreateStatusDropDown,
    GetDropDownBusinessUnitOnProject,
    GetAllDepartmentUnitDropDownOnProject,
    GetAllParentActivity,
    ParentActivitySave,
    GetParentActivityById,
    GetActivityCodeByParentId,
    GetallMyDepartment,
    ViewMyDepartment,
    SearchEmployeeByBussinessUnit,
    // GetLeaveDetails
    Remove,
    GetAllEmployeeFilterByBu,
    GetParentsorting,
    GetBusinessunitEmployee,
    TimeSheetResubmit,
    Timesheethistory,
    EmployeeTimesheetPending,
    MissingEmployee,
    WeekList,
    ProjectReport,
    Clientlist,
    Clientproject,
    Pdfgenerate,
    EmployeeGeneratePdf,
    ProjectReportPdf,
    MissingEmployeePdf,
    GetAllEmployeeByManagers,
    TransferEmployee,
    RemoveTimelogs,
    EmployeeExit,
    EmployeeResign,
    Excelgenerate,
    EmployeePdfgenerate,
    ProjectInherit,
    LeaveReport,
    LeaveReportPdf,
    GeneralActivity,
    GetGeneralActivity,
    Dashboard,
    Birthdaylist,
    Pendingconfirm,
    GetHistoryProjectById,
    MissingTime,
    Todaysabsent,
    Pendingleave,
    MissingTimesheetdash,
    EmpProjectDash,
    EmployeeDashboard,
    PrjClsCheckResource,
    GetPrjClsStatuslist,
    ProjectClosure,
    ResourceEffort,
    ResourceEffortPdf,
    ViewLeaveCountInPopup,
    Holiday,
    Leaveadd,
    DeleteLeave,
    NumberLeave,
    updateNumberLeave,
    EmpConfirm,
    Employeeconfirmcode,
    GetCompoffstatus,
    Compoffsave,
    Compoffbalance,
    Compoffgetall,
    CompoffApproval,
    Compoffupdate,
    CompoffApply,
    Compoffdelete,
    CompoffReport,
    CompoffReportPdf,
    Compoffdashboard,
    CompoffRegister,
    CompoffApplyleave,
    Compoffdatecheck,
    EmployeeLeaveUpdate,
    EmployeeUpdateview,
    EmployeeUpdatecancel,
    Employeeassign,
    EmployeeEffortPdf,
    EmployeeExcel,
    EmployeeLeavePdf,
    EmployeeLeaveExcel,
    EffortUtilizereport,
    EffortUtilize
}

export default service;